import utilsApi from "@/api/utils"

export function createFetchPageAction(
  collectionName,
  settingMutation,
  errorMutation,
  stateKey
) {
  return async ({ commit }, page) => {
    try {
      const apiResponse = await utilsApi.getPaginatedList(collectionName, page)
      if (apiResponse != null) {
        commit(settingMutation, {
          [stateKey]: apiResponse.items,
          count: apiResponse.total,
          page
        })
        return true
      } else {
        commit(errorMutation)
        return false
      }
    } catch (error) {
      console.error(`Error in FETCH_PAGE_${collectionName}:`, {
        message: error.message
      })
      commit(errorMutation)
      return false
    }
  }
}
